<template>
  <div class="c-app flex-row align-items-center amsys-header">
    <CWrapper>
      <CHeader fixed with-subheader light style="position: fixed;">
        <CToggler
          in-header
          class="ml-3 d-lg-none"
          @click="$store.commit('toggleSidebarMobile')"
        />
        <CToggler
          in-header
          class="ml-3 d-md-down-none"
          @click="$store.commit('toggleSidebarDesktop')"
        />
        <CHeaderBrand class="d-lg-none">
          <h3>
            <b>
              <font color="Green">PROFIT</font>
              <font color="gray">LOSS</font></b
            >
          </h3>
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto">
          <CHeaderNavItem class="px-3">
            <h3>
              <b>
                <font color="Green">PROFIT</font>
                <font color="gray">LOSS</font></b
              >
            </h3>
          </CHeaderNavItem>
        </CHeaderNav>
      </CHeader>
      <div class="c-body">
        <main class="c-main">
          <CRow>
            <CCol class="amsys-dashboard-parameter2">
              <select
                class="form-control"
                style="font-weight: bold; font-size:18px;"
                @change="reloadData()"
                v-model="selectedData"
              >
                <option
                  v-for="item in companyResult"
                  :value="item.Code"
                  :key="item.Code"
                >
                  {{ item.Code }}
                </option>
              </select>
            </CCol>
            <CCol class="amsys-dashboard-parameter2">
              <select
                class="form-control"
                style="font-weight: bold; font-size:18px;"
                @change="reloadData()"
                v-model="selectedYear"
              >
                <option
                  v-for="year in years()"
                  v-if="year >= 2015"
                  :value="year"
                  >{{ year }}</option
                >
              </select>
            </CCol>
          </CRow>
          <br />
          <CRow class="amsys-dashboard-row">
            <CCol class="amsys-dashboard-frame">
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b> <font color="white">PROFIT LOSS YEARLY</font></b>
                  </h5>
                </div>
                <div class="card-body">
                  <CCol style="width: 100%;padding: 0px;">
                    <DxChart
                      id="chart"
                      :data-source="company"
                      :customize-label="customizeLabel"
                      palette="Harmony Light"
                    >
                      <DxCommonSeriesSettings
                        argument-field="type"
                        type="bar"
                        hover-mode="allArgumentPoints"
                      >
                        <DxLabel :visible="false">
                          <DxFormat :precision="0" type="fixedPoint" />
                        </DxLabel>
                      </DxCommonSeriesSettings>
                      <DxSeries
                        value-field="coalProduction"
                        axis="frequency"
                        type="spline"
                        name="Monthly"
                      />
                      <DxSeries
                        value-field="cummulative"
                        axis="percentage"
                        type="spline"
                        name="Year-To-Date"
                      >
                      </DxSeries>
                      <DxValueAxis
                        :tick-interval="1500"
                        name="frequency"
                        position="left"
                      />
                      <DxValueAxis
                        :tick-interval="2000"
                        :show-zero="true"
                        :value-margins-enabled="false"
                        name="percentage"
                        position="right"
                      >
                        <DxConstantLine
                          :value="80"
                          :width="2"
                          color="#fc3535"
                          dash-style="dash"
                        >
                          <DxLabel :visible="false" />
                        </DxConstantLine>
                      </DxValueAxis>
                      <DxTooltip
                        :enabled="true"
                        :shared="true"
                        :customize-tooltip="customizeTooltip"
                      />

                      <DxLegend
                        vertical-alignment="top"
                        horizontal-alignment="center"
                      />
                    </DxChart>
                  </CCol>
                </div>
              </div>
              <br />
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b> <font color="white">PROFIT LOSS YEARLY</font></b>
                  </h5>
                </div>
                <div class="card-body">
                  <DxChart
                    id="chart3"
                    :data-source="company3"
                    :customize-label="customizeLabel"
                    title="Expense and Income"
                  >
                    <DxCommonSeriesSettings
                      argument-field="month"
                      type="bar"
                      hover-mode="allArgumentPoints"
                    >
                      <DxLabel :visible="true">
                        <DxFormat :precision="0" type="fixedPoint" />
                      </DxLabel>
                    </DxCommonSeriesSettings>
                    <DxSeries value-field="Income" name="Income" />
                    <DxSeries value-field="Expense" name="Expense" />
                    <DxLegend
                      vertical-alignment="bottom"
                      horizontal-alignment="center"
                    />
                    <DxTooltip
                      :enabled="true"
                      :customize-tooltip="customizeTooltip"
                    />
                    <!--format="millions"-->
                  </DxChart>
                </div>
              </div>
            </CCol>
          </CRow>
        </main>
      </div>
    </CWrapper>
  </div>
</template>
<script>
import { DxPieChart, DxConnector } from "devextreme-vue/pie-chart";
import {
  DxSeries,
  DxLegend,
  DxLabel,
  DxFont,
  DxExport,
  DxTooltip,
  DxChart,
  DxCommonSeriesSettings,
  DxArgumentAxis,
  DxGrid,
  DxCrosshair,
  DxPoint,
  DxTitle,
  DxSubtitle,
  DxValueAxis,
} from "devextreme-vue/chart";
import TheSidebar from "../../containers/TheSidebar";
import TheHeader from "../../containers/TheHeader";
import nav from "../../containers/_nav";
import Vue from "vue";
import axios from "axios";
import "@babel/polyfill";
import VueCordova from "vue-cordova";
import CryptoJS from "crypto-js";
Vue.use(VueCordova);

export default {
  components: {
    DxChart,
    DxCommonSeriesSettings,
    DxSeries,
    DxArgumentAxis,
    DxGrid,
    DxCrosshair,
    DxExport,
    DxLegend,
    DxPoint,
    DxLabel,
    DxFont,
    DxTitle,
    DxSubtitle,
    DxTooltip,
    DxValueAxis,
    DxPieChart,
    DxConnector,
  },
  nav,
  computed: {},
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      companyResult: [],
      selectedData: "CDE",
      company: [],
      company2: [],
      data: [],
      data2: [],
      showHeader: false,

      urlServer: "",
    };
  },
  methods: {
    show() {
      return this.$store.state.sidebarShow;
    },
    Minimize() {
      return this.$store.state.sidebarMinimize;
    },
    customizeLabel({ value }) {
      return {
        //visible: true,
        customizeText: function({ valueText }) {
          var currency = "";
          if (valueText >= 1000 && valueText < 1000000) {
            valueText = valueText / 1000;
            currency = " K";
          } else if (valueText >= 1000000 && valueText < 1000000000) {
            valueText = valueText / 1000000;
            currency = " M";
          } else if (valueText >= 1000000000) {
            valueText = valueText / 1000000000;
            currency = " B";
          }
          //return `Rp. ${valueText.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} M`;
          return (
            `Rp. ${valueText
              .toFixed(2)
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}` + currency
          );
        },
      };
    },
    customizeText({ valueText }) {
      //return `Rp. ${valueText.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} M`;
      var currency = "";
      if (valueText >= 1000 && valueText < 1000000) {
        valueText = valueText / 1000;
        currency = " K";
      } else if (valueText >= 1000000 && valueText < 1000000000) {
        valueText = valueText / 1000000;
        currency = " M";
      } else if (valueText >= 1000000000) {
        valueText = valueText / 1000000000;
        currency = " B";
      }
      //return `Rp. ${valueText.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} M`;
      //return `Rp. ${valueText.toString()}`;
      return (
        `Rp. ${valueText
          .toFixed(2)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}` + currency
      );
    },
    customizeTooltip(pointInfo) {
      return {
        text: `${pointInfo.argumentText} <br/> Rp. ${pointInfo.value
          .toFixed(2)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`,
      };
    },
    years() {
      const year = new Date().getFullYear();
      return Array.from(
        { length: year - 1900 },
        (value, index) => 1901 + index
      );
    },
    reloadData() {
      let data = localStorage.token;
      const param = { Company: this.selectedData, Year: this.selectedYear };
      if (this.selectedData != "undefined") {
        this.data = new Array();
        this.company = new Array();
        this.data2 = new Array();
        this.company2 = new Array();

        const items = [this.selectedData];
        this.data = [{ value: [this.selectedData], name: [this.selectedData] }];

        if (typeof data != "undefined") {
          var prExpenseIncome = new Array();
          this.company3 = new Array();
          const pl = new Array();
          var mon = "";

          axios
            .post(`${this.urlServer}/Api/Dashboard/ExpenseIncome/`, param, {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + data,
              },
            })
            .then((res) => {
              var i, x;
              for (i = 0; i < res.data.length; i++) {
                // console.log(res.data[i].MonthName);
                var mon1 = res.data[i].MonthName;
                if (mon1 != mon) {
                  var objs = new Object();
                  objs["month"] = mon1;
                  for (x = 0; x < res.data.length; x++) {
                    if (res.data[i].MonthName == res.data[x].MonthName) {
                      if (res.data[x].GeneralType == "Income") {
                        objs["Income"] = parseFloat(
                          res.data[x].Amount.toFixed(2)
                        );
                        //objs["Income"] = res.data[x].Amount.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
                      } else {
                        objs["Expense"] = parseFloat(
                          res.data[x].Amount.toFixed(2)
                        );
                      }
                    }
                  }
                  prExpenseIncome.push(objs);
                  mon = mon1;
                }
              }
              this.company3 = prExpenseIncome;
              if (typeof data != "undefined") {
                axios
                  .post(
                    `${this.urlServer}/Api/Dashboard/ProfitYearly2/`,
                    param,
                    {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + data,
                      },
                    }
                  )
                  .then((res) => {
                    var i, x;
                    for (i = 0; i < res.data.length; i++) {
                      var mon1 = res.data[i].MonthName;
                      if (mon1 != mon) {
                        var objs = new Object();
                        objs["type"] = mon1;
                        for (x = 0; x < res.data.length; x++) {
                          if (res.data[i].MonthName == res.data[x].MonthName) {
                            if (res.data[x].Type == "Profit") {
                              objs["coalProduction"] = res.data[x].Amount;
                            } else {
                              objs["cummulative"] = res.data[x].Amount;
                            }
                          }
                        }
                        pl.push(objs);
                        mon = mon1;
                      }
                    }
                    this.company = pl;
                    this.loading = false;
                  })
                  .catch((error) => {
                    this.loading = false;
                    console.error(error);
                  });
              } else {
                this.loading = false;
                this.$router.push({ path: "/logout" });
              }

              this.loading = false;
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });
        } else {
          this.loading = false;
          this.$router.push({ path: "/logout" });
        }
      } else {
      }
      this.loading = false;
    },
  },
  beforeMount() {
    this.loading = true;
    const stringToProtect = "Amsys_2@2021";
    let url = CryptoJS.AES.decrypt(localStorage.url, stringToProtect);
    const urlS = url.toString(CryptoJS.enc.Utf8);
    this.urlServer = urlS;
    let data = localStorage.token;
    const param = { Company: "PT. CAKRAWALA DINAMIKA ENERGI", Year: "2019" };
    const form = new FormData();
    form.append("CompanyOid", this.selectedData);
    let sendData = JSON.stringify(Object.fromEntries(form));
    if (typeof data != "undefined") {
      axios
        .post(`${urlS}/Api/General/GetCompany/`, sendData, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          this.companyResult = res.data;
        })
        .catch((error) => {
          let err = error.toString();
          if (err.toString().match(/^.*undefined.*$/)) {
            Vue.$toast.open({
              message: "Sorry, Your token has expired!",
              type: "warning",
              position: "bottom",
            });
            this.$router.push({ path: "/logout" });
          } else {
            Vue.$toast.open({
              message: error,
              type: "error",
              position: "bottom",
            });
          }
        });
    } else {
      this.$router.push({ path: "/logout" });
    }
    this.reloadData();
    this.loading = false;
  },
};
</script>
<style>
#chart {
  height: 440px;
}
</style>
